import { useQuery } from '@tanstack/react-query';

import { planRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const usePlanGroup = (currency = '', count = 0, usage?: string, planGroupId?: number) => {
  const query = useQuery({
    queryKey: [QueryKeys.PLAN_GROUP, { currency, count, usage, planGroupId }],
    queryFn: () => planRepo.getPlanGroup(currency, count, usage, planGroupId),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: !!currency,
  });

  return useQueryMemoized(query);
};

export type UsePlanGroup = ReturnType<typeof usePlanGroup>;
